var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: () => (_vm.open = false),
          expression: "() => (open = false)",
        },
      ],
      staticClass: "custom-select",
      attrs: { tabindex: _vm.tabindex },
    },
    [
      _c(
        "div",
        {
          staticClass: "selected",
          class: { open: _vm.open },
          on: {
            click: function ($event) {
              _vm.open = !_vm.open
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "selected-text",
              attrs: { title: _vm.selectedText },
            },
            [_vm._v(" " + _vm._s(_vm.selectedText) + " ")]
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "items", class: { selectHide: !_vm.open } },
        [
          !_vm.filteredResults.length
            ? _c("label", { staticClass: "empty-list" }, [
                _vm._v(" " + _vm._s(_vm.$t("noItemsMatched")) + " "),
              ])
            : _vm._e(),
          _vm._l(_vm.filteredResults, function (option, i) {
            return _c(
              "div",
              {
                key: i,
                on: {
                  click: function ($event) {
                    _vm.selected = option
                    _vm.open = false
                    _vm.$emit("input", option)
                  },
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.displayKey !== "" ? option[_vm.displayKey] : option
                    ) +
                    " "
                ),
              ]
            )
          }),
        ],
        2
      ),
      _vm.open
        ? _c(
            "div",
            { staticClass: "search-filter" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.search,
                    expression: "search",
                  },
                ],
                staticClass: "search",
                attrs: {
                  type: "text",
                  placeholder: _vm.$t("search"),
                  "max-length": "100",
                },
                domProps: { value: _vm.search },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.search = $event.target.value
                  },
                },
              }),
              _c("font-awesome-icon", {
                staticClass: "search-icon fa-lg",
                attrs: { icon: ["fas", "search"] },
              }),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.search !== "",
                      expression: "search !== ''",
                    },
                  ],
                  staticClass: "clear-search",
                  on: { click: () => (_vm.search = "") },
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "clear",
                    attrs: { icon: ["fas", "times"] },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }